"use client";
import AuthModal from "@/components/AuthModal/AuthModal";
import ForgotPasswordForm from "@/components/AuthModal/forms/ForgotPasswordForm/ForgotPasswordForm";
import LoginForm from "@/components/AuthModal/forms/LoginForm/LoginForm";
import SignUpForm from "@/components/AuthModal/forms/SignUpForm/SignUpForm";
import React, { createContext, useState, useContext, ReactNode } from "react";
import { useUserContext } from "./UserContext";
import { useThemeContext } from "./ThemeContext";
import { IAuthModal } from "@/interfaces/context/auth-modal";

interface AuthModalContextProps {
  children: ReactNode;
  googleApi: string;
}
interface AuthModalContextValues {
  setAuthModal: React.Dispatch<React.SetStateAction<IAuthModal>>;
}

const AuthModalContext = createContext<AuthModalContextValues | undefined>(
  undefined
);

export const AuthModalProvider: React.FC<AuthModalContextProps> = ({
  children,
  googleApi,
}) => {
  const { theme } = useThemeContext();
  const [authModal, setAuthModal] = useState<IAuthModal>({
    show: false,
    form: "",
    referralId: null,
  });
  const { handleLogin } = useUserContext();
  const values = {
    setAuthModal,
  };
  return (
    <AuthModalContext.Provider value={values}>
      {children}
      <AuthModal
        show={authModal.show}
        onHide={() => setAuthModal({ show: false, form: "", referralId: null })}
        theme={theme}
      >
        {authModal.form === "login" && (
          <LoginForm
            authModal={authModal}
            setAuthModal={setAuthModal}
            handleLogin={handleLogin}
            googleApi={googleApi}
          />
        )}
        {authModal.form === "signUp" && (
          <SignUpForm
            authModal={authModal}
            setAuthModal={setAuthModal}
            googleApi={googleApi}
          />
        )}
        {authModal.form === "forgotPassword" && (
          <ForgotPasswordForm
            authModal={authModal}
            setAuthModal={setAuthModal}
          />
        )}
      </AuthModal>
    </AuthModalContext.Provider>
  );
};

export const useAuthModal = (): AuthModalContextValues => {
  const context = useContext(AuthModalContext);
  if (context === undefined) {
    throw new Error("useAuthModal must be used within an AuthModalProvider");
  }
  return context;
};
